class ViewAsComponent extends HTMLElement {
  connectedCallback() {
    this.buttonList = this.querySelector('.view-as__list-button');
    this.buttonGrid = this.querySelector('.view-as__grid-button');

    this.boundListClick = () => this.setView('list');
    this.boundGridClick = () => this.setView('grid');
    this.boundMaintainView = () => this.maintainViewState();

    if (!this.buttonList || !this.buttonGrid) return;

    this.buttonList.addEventListener('click', this.boundListClick);
    this.buttonGrid.addEventListener('click', this.boundGridClick);

    const savedView =
      localStorage.getItem('searchViewMode') || this.getAttribute('products-view') || 'grid';

    this.observer = new MutationObserver(this.boundMaintainView);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        this.hitsContainer = document.querySelector('#hits');
        this.setView(savedView, { refresh: false });
        if (this.hitsContainer) {
          if (this.observer) {
            this.observer.observe(this.hitsContainer, { childList: true, subtree: true });
          }
        }
      });
    } else {
      this.hitsContainer = document.querySelector('#hits');
      this.setView(savedView, { refresh: false });
      if (this.hitsContainer) {
        this.observer.observe(this.hitsContainer, { childList: true, subtree: true });
      }
    }
  }

  disconnectedCallback() {
    if (this.buttonList) {
      this.buttonList.removeEventListener('click', this.boundListClick);
    }
    if (this.buttonGrid) {
      this.buttonGrid.removeEventListener('click', this.boundGridClick);
    }
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  setView(view, { refresh = true } = {}) {
    if (!['grid', 'list'].includes(view)) return;

    this.updateButtonState(view);
    this.updateHitsContainer(view);
    localStorage.setItem('searchViewMode', view);

    if (refresh && window.__instantSearchInstance) {
      window.__instantSearchInstance.refresh();
    }
  }

  updateButtonState(view) {
    const listIcon = this.buttonList?.querySelector('.view-as__icon');
    const gridIcon = this.buttonGrid?.querySelector('.view-as__icon');

    if (!listIcon || !gridIcon) return;

    listIcon.classList.toggle('view-as__icon--active', view === 'list');
    gridIcon.classList.toggle('view-as__icon--active', view === 'grid');
  }

  updateHitsContainer(view) {
    const hits = document.querySelector('#hits');
    if (!hits) return;

    hits.classList.remove('search-products--grid', 'search-products--list');
    hits.classList.add(`search-products--${view}`);
  }

  maintainViewState() {
    const currentView =
      localStorage.getItem('searchViewMode') || this.getAttribute('products-view') || 'grid';
    this.updateHitsContainer(currentView);
  }
}

customElements.define('view-as-component', ViewAsComponent);
